var i = /* @__PURE__ */ ((e) => (e.search_suggestions = "search_suggestions", e.search = "search", e.product_impression = "product_impression", e.scroll = "scroll", e.generic_click = "generic_click", e.screen_view = "screen_view", e.sign_up = "sign_up", e.sign_in = "sign_in", e.sign_out = "sign_out", e.tab = "tab", e.link_account = "link_account", e.shop_click = "shop_click", e.screen_redirect = "screen_redirect", e.show_popup = "show_popup", e.close_popup = "close_popup", e.withdraw_funds = "withdraw_funds", e.add_to_favourites = "add_to_favourites", e.remove_from_favourites = "remove_from_favourites", e.play_media = "play_media", e.pause_media = "pause_media", e.skip_to_media = "skip-to_media", e.product_action = "product_action", e.copy_coupon = "copy_coupon", e.error = "error", e))(i || {}), r = /* @__PURE__ */ ((e) => (e.page_view = "page_view", e.screen_redirect = "screen_redirect", e.click_signup = "click-signup", e.click_signin = "click-signin", e.click_signout = "click-signout", e.click_settings_switch_tab = "click-setting-switch_tab", e.click_settings_link_bank_account = "click-settings-link_bank_account", e.click_settings_link_paypal = "click-settings-link_paypal", e.popup_web_joinnow_show = "popup_web_joinnow_show", e.popup_web_joinnow_close = "popup_web_joinnow_close", e.click_otp_flow_add_mobile = "click-otp-flow-add_mobile", e.click_add_update_mobile = "click-add_update_mobile", e.click_add_update_mobile_success = "click-add_update_mobile_success", e.click_verify_mobile = "click-verify_mobile", e.popup_captcha = "popup-captcha", e.click_verify_captcha_fail = "click-verify_captcha_fail", e.click_verify_captcha_success = "click-verify_captcha_success", e.popup_otp_verify_code_show = "popup-otp_verify_code-show", e.click_verify_mobile_success = "click-verify_mobile_success", e.popup_otp_mfa_show = "popup-otp-mfa-show", e.click_mfa_success = "click-mfa_success", e.click_mfa_fail = "click-mfa_fail", e.popup_compromised_password_show = "popup-compromised_password-show", e.popup_compromised_password_without_mobile_show = "popup-compromised_password_without_mobile-show", e.popup_save_new_password_show = "popup-save_new_password-show", e.popup_reset_password_email_confirm_show = "popup-reset_password_email_confirm-show", e.click_create_new_password = "click-create_new_password", e.click_save_new_password = "click-save_new_password", e.click_save_new_password_success = "click-save_new_password_success", e.click_send_reset_password_email = "click-send_reset_password_email", e.click_signin_email = "click-signin_email", e.impression_search_web_search_suggestion = "impression-search_web-search_suggestion", e.search_search_web_search = "search-search_web-search", e.impression_search_web_view_search_results = "impression-search_web-view_search_results", e.scroll_search_web_scroll = "scroll-search_web-scroll", e.impression_web_search_card_render = "impression-web-search-card-render", e.impression_web_search_card_viewed = "impression-web-search-card-viewed", e.click_web_search_card = "click-web-search-card", e.scroll_shophome = "scroll-shophome", e.impression_shophome_carousel = "impression-shophome-carousel", e.click_web_merchant = "click-web-merchant", e.click_shophome_exit = "click-shophome-exit", e.click_merchant_view_switch_tab = "click-merchant-view_switch_tab", e.scroll_merchant_scroll_merchant_page = "scroll-merchant-scroll_merchant_page", e.click_merchant_shop_now = "click-merchant-shop_now", e.click_merchant_add_to_favourites = "click-merchant-add_to_favourites", e.click_merchant_remove_from_favourites = "click-merchant-remove_from_favourites", e.popup_merchant_categories_show = "popup-merchant-categories_show", e.popup_merchant_offers_show = "popup-merchant-offers_show", e.impression_web_banner_render = "impression-web-banner-render", e.impression_web_banner_viewed = "impression-web-banner-viewed", e.click_web_banner = "click-web-banner", e.click_merchant_view_terms = "click-merchant-view_terms", e.popup_notifier_web_promo_show = "popup-notifier_web_promo-show", e.popup_notifier_web_promo_close = "popup-notifier_web_promo-close", e.click_notifier_web_promo_click = "click-notifier_web_promo-click", e.search_myrewards_transaction = "search-myrewards-transaction", e.search_myrewards_withdrawal = "search-myrewards-withdrawal", e.click_myrewards_history = "search-myrewards-history", e.scroll_myrewards = "scorll-myrewards", e.scroll_clickhistory = "scroll_clickhistory", e.search_clickhistory = "search_clickhistory", e.popup_linkaccount_show = "popup-linkaccount-show", e.popup_chooseaccount_show = "popup-chooseaccount-show", e.popup_enteramount_show = "popup-enteramount-show", e.popup_insufficientfund_show = "popup_insufficientfund-show", e.click_web_copy_coupon = "click-web-copy_coupon", e.click_web_withdraw = "click-web-withdraw", e.click_myrewards_show_detail = "click-myrewards-show_detail", e.click_myrewards_transaction_filters = "click-myrewards-transaction_filters", e.click_myrewards_withdrawal_filters = "click-myrewards-withdrawal_filters", e.click_myrewards_switch_tab = "click-myrewards-switch_tab", e.click_mobileapp_load = "click-mobileapp-load", e.click_mobileapp_exit = "click-mobileapp-exit", e.click_mobileapp_switch_tab = "click-mobileapp-switch_tab", e.click_mobileapp_signup = "click-mobileapp-signup", e.click_mobileapp_signin = "click-mobileapp-signin", e.click_mobileapp_signout = "click-mobileapp-signout", e.click_ad_unit = "click-ad-unit", e.dismiss_ad_unit = "dismiss-ad-unit", e.impression_ad_unit_loaded = "impression-web-ad-unit-loaded", e.impression_ad_unit_render = "impression-web-ad-unit-render", e.video_ad_start = "video-ad-start", e.video_ad_first_quartile = "video-ad-first-quartile", e.video_ad_midpoint = "video-ad-midpoint", e.video_ad_third_quartile = "video-ad-third-quartile", e.video_ad_completed = "video-ad-completed", e.scroll_page = "scroll-page", e.scroll_element = "scroll-element", e.click_generic = "click-generic", e.impression_run_of_market_carousel = "impression-run-of-market-carousel", e.click_run_of_market_carousel = "click-run-of-market-carousel", e.impression_web_carousel = "impression-web-carousel", e.impression_web_carousel_viewed = "impression-web-carousel-viewed", e.click_web_article = "click-web-article", e.impression_web_category_merchant_list = "impression-web-category-merchant_list", e.impression_web_search_banner = "impression-web-search-banner", e.click_partner_join = "click_partner_join", e.click_partner_signin = "click_partner_signin", e.error_call_apis = "error_call_apis", e.recently_viewed_click = "recently-viewed-click", e.recently_viewed_scroll = "recently-viewed-scroll", e.impression_recently_viewed_web = "impression-recently-viewed-web", e.favourites_click = "favourites-click", e.promotions_click = "promotions-click", e.promotions_activate_click = "promotions-activate-click", e.impression_promotions = "impression-promotions", e))(r || {}), u = /* @__PURE__ */ ((e) => (e[e.Unknown = 0] = "Unknown", e[e.Navigation = 1] = "Navigation", e[e.Location = 2] = "Location", e[e.Search = 3] = "Search", e[e.Transaction = 4] = "Transaction", e[e.UserContent = 5] = "UserContent", e[e.UserPreference = 6] = "UserPreference", e[e.Social = 7] = "Social", e[e.Other = 8] = "Other", e[e.Media = 9] = "Media", e[e.Viewed = 10] = "Viewed", e))(u || {}), z = /* @__PURE__ */ ((e) => (e.onboarding = "onboarding-organic", e.transaction = "transaction", e.raf = "raf", e.withdrawal = "withdrawal", e.shopNow = "shop_now", e.favourites = "favourites", e))(z || {}), Q = /* @__PURE__ */ ((e) => (e.top = "top", e.nav = "nav", e.bottom = "bottom", e.footer = "footer", e.header = "header", e.main = "main", e.other = "other", e.side = "side", e.middle = "middle", e))(Q || {}), Z = /* @__PURE__ */ ((e) => (e.shop_now = "shop_now", e.continue = "continue", e.provide_details = "provide_details", e.send_code = "send_code", e.join = "join", e.decline = "decline", e.sign_in = "sign_in", e.sign_out = "sign_out", e.verify_code = "verify_code", e.resent_code = "resent_code", e.close = "close", e.add_to_browser = "add_to_browser", e.dismiss = "dismiss", e.sort = "sort", e.switch_tab = "switch_tab", e.redirect = "redirect", e.expand = "expand", e.collapse = "collapse", e.other = "other", e.link_card = "link-card", e))(Z || {}), K = /* @__PURE__ */ ((e) => (e.grid = "grid", e.carousel = "carousel", e.list = "list", e.banner = "banner", e.featured_offers = "featured_offer", e.increased_offers = "increased_offer", e.store = "popular_stores", e.instore = "instore_merchants", e.trending_store = "trending_stores", e.personalised_store = "personalised_stores", e.gift_card = "gift_card", e.featured_articles = "featured_articles", e))(K || {}), W = /* @__PURE__ */ ((e) => (e.grid = "grid", e.carousel = "carousel", e.list = "list", e.other = "other", e))(W || {}), X = /* @__PURE__ */ ((e) => (e.instant = "instant", e.search_cta = "search_cta", e.suggestion = "suggestion", e.sort = "sort", e.other = "other", e))(X || {}), F = /* @__PURE__ */ ((e) => (e.page = "page", e.element = "element", e.other = "other", e))(F || {}), B = /* @__PURE__ */ ((e) => (e.vertical = "vertical", e.horizontal = "horizontal", e))(B || {}), D = /* @__PURE__ */ ((e) => (e[e.Unknown = 0] = "Unknown", e[e.AddToCart = 1] = "AddToCart", e[e.RemoveFromCart = 2] = "RemoveFromCart", e[e.Checkout = 3] = "Checkout", e[e.CheckoutOption = 4] = "CheckoutOption", e[e.Click = 5] = "Click", e[e.ViewDetail = 6] = "ViewDetail", e[e.Purchase = 7] = "Purchase", e[e.Refund = 8] = "Refund", e[e.AddToWishlist = 9] = "AddToWishlist", e[e.RemoveFromWishlist = 10] = "RemoveFromWishlist", e))(D || {}), S = /* @__PURE__ */ ((e) => (e.appstore = "appstore", e.codepush = "codepush", e.other = "other", e))(S || {}), G = /* @__PURE__ */ ((e) => (e.merchants = "merchants", e.products = "products", e.elements = "elements", e.clicks = "clicks", e.transactions = "transactions", e.other = "other", e.keywords = "keywords", e.ads = "ads", e.articles = "articles", e.null = "null", e))(G || {}), U = /* @__PURE__ */ ((e) => (e.cashrewards = "cashrewards", e.kevel = "kevel", e.other = "other", e))(U || {}), H = /* @__PURE__ */ ((e) => (e.marketplace = "marketplace", e.travel = "travel", e.tech_electrical = "tech_electrical", e.retail = "retail", e.qsr = "qsr", e.fashion = "fashion", e.liquor = "liquor", e.beauty = "beauty", e.sports = "sports", e.fitness_outdoor = "fitness_outdoor", e.uncategorised = "uncategorised", e.food_grocery = "food_grocery", e.utilities_finance = "utilities_finance", e.home = "home", e.motor = "motor", e.pet_kids = "pet_kids", e.giftcard = "giftcard", e.health_pharmacy = "health_pharmacy", e))(H || {}), P = /* @__PURE__ */ ((e) => (e.sports_fitness = "sports_fitness", e.finance = "finance", e.health = "health", e.pharmacy = "pharmacy", e.marketplace = "marketplace", e.kids = "kids", e.utilities = "utilities", e.insurance = "insurance", e.hotels_accomodation = "hotels_accomodation", e.tech_electrical = "tech_electrical", e.entertainment = "entertainment", e.subscriptions = "subscriptions", e.retail = "retail", e.qsr = "qsr", e.fashion = "fashion", e.home = "home", e.liquor = "liquor", e.beauty = "beauty", e.flights = "flights", e.car_hire = "car_hire", e.grocery_convenience = "grocery_convenience", e.uncategorised = "uncategorised", e.motor = "motor", e.pet = "pet", e.outdoor = "outdoor", e.cafes_restaurants = "cafes_restaurants", e.mobile = "mobile", e.giftcard = "giftcard", e))(P || {}), L = /* @__PURE__ */ ((e) => (e.default = "default", e.relevance = "relevance", e.highest_online = "highest_online", e.highest_instore = "highest_instore", e.other = "other", e))(L || {}), I = /* @__PURE__ */ ((e) => (e.notifier_web = "notifier_web", e.notifier_mobile = "notifier_mobile", e.mobileapp = "mobileapp", e.web = "web", e.anzplus = "anzplus", e.other = "other", e))(I || {}), Y = /* @__PURE__ */ ((e) => (e.email = "email", e.facebook = "facebook", e.link = "link", e.resend = "resend", e.other = "other", e))(Y || {}), V = /* @__PURE__ */ ((e) => (e.cashrewards = "cashrewards", e.google = "google", e.facebook = "facebook", e.apple = "apple", e))(V || {}), C = /* @__PURE__ */ ((e) => (e.promo_code = "promo_code", e.coupon_code = "coupon_code", e.activation_code = "activation_code", e.other = "other", e))(C || {}), M = /* @__PURE__ */ ((e) => (e.email = "email", e.sms = "sms", e.other = "other", e))(M || {}), O = /* @__PURE__ */ ((e) => (e.app = "app", e.notifier = "notifier", e.web = "web", e.instore = "instore", e.other = "other", e))(O || {}), R = /* @__PURE__ */ ((e) => (e.non_control = "non-control", e.general = "general", e.ad = "ad", e.campaign = "campaign", e))(R || {}), A = /* @__PURE__ */ ((e) => (e.subscribed = "subscribed", e.unsubscribed = "unsubscribed", e.opted_in = "opted_in", e))(A || {}), h = /* @__PURE__ */ ((e) => (e.login = "login", e.logout = "logout", e.modify = "modify", e))(h || {}), N = /* @__PURE__ */ ((e) => (e.low = "low", e.medium = "medium", e.high = "high", e.critical = "critical", e))(N || {}), T = /* @__PURE__ */ ((e) => (e.internal_system = "internal_system", e.member_facing = "member_facing", e.all = "all", e))(T || {});
const J = /* @__PURE__ */ new Map([
  [r.page_view, i.screen_view],
  // screen_view => logPageView
  [r.screen_redirect, i.screen_redirect],
  [
    r.impression_search_web_search_suggestion,
    i.search_suggestions
  ],
  // product_impression => logImpression
  [r.search_search_web_search, i.search],
  [
    r.impression_search_web_view_search_results,
    i.product_impression
  ],
  // product_impression => logImpression
  [r.impression_ad_unit_loaded, i.product_impression],
  // product_impression => logImpression
  [r.impression_ad_unit_render, i.product_impression],
  // product_impression => logImpression
  [r.impression_shophome_carousel, i.product_impression],
  // product_impression => logImpression
  [
    r.impression_web_search_card_render,
    i.product_impression
  ],
  // product_impression => logImpression
  [
    r.impression_web_search_card_viewed,
    i.product_impression
  ],
  // product_impression => logImpression
  [r.click_web_search_card, i.generic_click],
  [
    r.click_myrewards_transaction_filters,
    i.product_impression
  ],
  [
    r.click_myrewards_withdrawal_filters,
    i.product_impression
  ],
  [r.scroll_clickhistory, i.scroll],
  [r.scroll_merchant_scroll_merchant_page, i.scroll],
  [r.scroll_myrewards, i.scroll],
  [r.scroll_search_web_scroll, i.scroll],
  [r.scroll_shophome, i.scroll],
  [r.dismiss_ad_unit, i.generic_click],
  [r.click_ad_unit, i.generic_click],
  [r.click_merchant_view_switch_tab, i.tab],
  [r.click_merchant_shop_now, i.shop_click],
  [r.click_myrewards_history, i.screen_redirect],
  [r.search_myrewards_transaction, i.search],
  [r.search_myrewards_withdrawal, i.search],
  [r.search_clickhistory, i.search],
  [r.click_shophome_exit, i.screen_redirect],
  [r.click_signup, i.sign_up],
  [r.click_signin, i.sign_in],
  [r.click_signout, i.sign_out],
  [r.click_settings_switch_tab, i.tab],
  [r.click_settings_link_bank_account, i.link_account],
  [r.click_settings_link_paypal, i.link_account],
  [r.click_web_withdraw, i.withdraw_funds],
  [
    r.click_merchant_add_to_favourites,
    i.add_to_favourites
  ],
  [
    r.click_merchant_remove_from_favourites,
    i.remove_from_favourites
  ],
  [r.click_myrewards_show_detail, i.product_impression],
  [r.click_myrewards_switch_tab, i.tab],
  [r.click_partner_join, i.screen_redirect],
  [r.click_partner_signin, i.screen_redirect],
  [r.click_otp_flow_add_mobile, i.generic_click],
  [r.click_verify_mobile, i.generic_click],
  [r.click_add_update_mobile, i.generic_click],
  [r.click_add_update_mobile_success, i.generic_click],
  [r.click_verify_mobile_success, i.generic_click],
  [r.click_verify_captcha_fail, i.generic_click],
  [r.click_verify_captcha_success, i.generic_click],
  [r.click_mfa_success, i.generic_click],
  [r.click_mfa_fail, i.generic_click],
  [r.click_create_new_password, i.generic_click],
  [r.click_save_new_password, i.generic_click],
  [r.click_save_new_password_success, i.generic_click],
  [r.click_send_reset_password_email, i.generic_click],
  [r.click_signin_email, i.generic_click],
  [r.popup_captcha, i.show_popup],
  [r.popup_otp_verify_code_show, i.show_popup],
  [r.popup_otp_mfa_show, i.show_popup],
  [r.popup_compromised_password_show, i.show_popup],
  [
    r.popup_compromised_password_without_mobile_show,
    i.show_popup
  ],
  [r.popup_save_new_password_show, i.show_popup],
  [
    r.popup_reset_password_email_confirm_show,
    i.show_popup
  ],
  [r.popup_web_joinnow_show, i.show_popup],
  [r.popup_web_joinnow_close, i.close_popup],
  [r.popup_linkaccount_show, i.show_popup],
  [r.popup_chooseaccount_show, i.show_popup],
  [r.popup_enteramount_show, i.show_popup],
  [r.popup_insufficientfund_show, i.show_popup],
  [r.popup_merchant_categories_show, i.show_popup],
  [r.popup_merchant_offers_show, i.show_popup],
  [r.popup_notifier_web_promo_show, i.show_popup],
  [r.popup_notifier_web_promo_close, i.close_popup],
  [r.click_notifier_web_promo_click, i.product_action],
  [r.video_ad_start, i.play_media],
  [r.video_ad_first_quartile, i.play_media],
  [r.video_ad_midpoint, i.play_media],
  [r.video_ad_third_quartile, i.play_media],
  [r.video_ad_completed, i.play_media],
  [r.scroll_page, i.scroll],
  [r.scroll_element, i.scroll],
  [r.click_generic, i.generic_click],
  [r.impression_web_banner_render, i.product_impression],
  [r.impression_web_banner_viewed, i.product_impression],
  [r.click_web_banner, i.generic_click],
  [
    r.impression_run_of_market_carousel,
    i.product_impression
  ],
  [r.click_run_of_market_carousel, i.generic_click],
  [r.impression_web_carousel, i.product_impression],
  [
    r.impression_web_carousel_viewed,
    i.product_impression
  ],
  [r.click_web_article, i.generic_click],
  [r.click_merchant_view_terms, i.generic_click],
  [r.click_web_copy_coupon, i.copy_coupon],
  [
    r.impression_web_category_merchant_list,
    i.product_impression
  ],
  [r.impression_web_search_banner, i.product_impression],
  [r.error_call_apis, i.error],
  [r.recently_viewed_click, i.generic_click],
  [r.recently_viewed_scroll, i.scroll],
  [
    r.impression_recently_viewed_web,
    i.product_impression
  ],
  [r.favourites_click, i.generic_click],
  [r.promotions_click, i.generic_click],
  [r.promotions_activate_click, i.generic_click],
  [r.impression_promotions, i.product_impression]
]), E = "PartnerStore", ee = () => {
  if (typeof localStorage > "u")
    return null;
  const e = localStorage.getItem(E);
  return e ? JSON.parse(e) : null;
};
class ce {
  constructor() {
    this.env = "local", this.disableTracking = !1;
  }
  init(o) {
    const t = o.metricsServer || "cdp.cashrewards.com.au";
    this.env = (o.env || "").toLowerCase();
    const s = this.env !== "prelive" && this.env !== "live", a = s ? "tag_a_thon_test" : "master";
    o && o.disableTracking && (this.disableTracking = o.disableTracking);
    const n = {
      // try to get app name and version from package.json
      appName: o.appName,
      appVersion: o.version,
      isDevelopmentMode: s,
      logLevel: s ? "verbose" : "warning",
      v1SecureServiceUrl: `${t}/webevents/v1/JS/`,
      v2SecureServiceUrl: `${t}/webevents/v2/JS/`,
      v3SecureServiceUrl: `${t}/webevents/v3/JS/`,
      configUrl: `${t}/tags/JS/v2/`,
      identityUrl: `${t}/identity/v1/`,
      aliasUrl: `${t}/webevents/v1/identity/`,
      // Config the Data Play ID and Version, it should be updated in the configurator.json
      dataPlan: {
        planId: o.mParticleDataPlan || a,
        planVersion: parseInt(o.mParticleDataPlanVersion ?? "", 10) || 1
      },
      // This callback will be called when mParticle succesfully initializes
      // and will return any known user identies from mParticle.
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      identityCallback: () => {
      }
    }, c = o.mParticleApiKey;
    if (!c) {
      console.error("mParticle api key is required");
      return;
    }
    typeof window == "object" && !window.mParticle && (window.mParticle = {}, window.mParticle.config = n, function(v) {
      var q;
      window.mParticle = window.mParticle || {}, window.mParticle.EventType = {
        Unknown: 0,
        Navigation: 1,
        Location: 2,
        Search: 3,
        Transaction: 4,
        UserContent: 5,
        UserPreference: 6,
        Social: 7,
        Other: 8,
        Media: 9,
        Viewed: 10
      }, window.mParticle.eCommerce = { Cart: {} }, window.mParticle.Identity = {}, window.mParticle.config = window.mParticle.config || {}, window.mParticle.config.rq = [], window.mParticle.config.snippetVersion = 2.3, window.mParticle.ready = function(l) {
        window.mParticle.config.rq.push(l);
      };
      const d = [
        "endSession",
        "logError",
        "logBaseEvent",
        "logEvent",
        "logForm",
        "logLink",
        "logPageView",
        "setSessionAttribute",
        "setAppName",
        "setAppVersion",
        "setOptOut",
        "setPosition",
        "startNewSession",
        "startTrackingLocation",
        "stopTrackingLocation"
      ], m = ["setCurrencyCode", "logCheckout"], k = ["identify", "login", "logout", "modify"];
      function _(l, j) {
        return function() {
          j && (l = j + "." + l);
          const x = Array.prototype.slice.call(arguments);
          x.unshift(l), window.mParticle.config.rq.push(x);
        };
      }
      d.forEach(function(l) {
        window.mParticle[l] = _(l);
      }), m.forEach(function(l) {
        window.mParticle.eCommerce[l] = _(l, "eCommerce");
      }), k.forEach(function(l) {
        window.mParticle.Identity[l] = _(l, "Identity");
      });
      const $ = window.mParticle.config.isDevelopmentMode ? 1 : 0;
      let g, p, b = "?env=" + $;
      const f = window.mParticle.config.dataPlan;
      f && (g = f.planId, p = f.planVersion, g && (p && (p < 1 || p > 1e3) && (p = null), b += "&plan_id=" + g + (p ? "&plan_version=" + p : "")));
      const w = document.createElement("script");
      w.type = "text/javascript", w.async = !0, w.src = (document.location.protocol === "https:" ? "https://" : "http://") + "cdp.cashrewards.com.au/tags/JS/v2/" + v + "/mparticle.js" + b;
      const y = document.getElementsByTagName("script")[0];
      (q = y.parentNode) == null || q.insertBefore(w, y);
    }(c));
  }
  getMparticleEventName(o) {
    return J.get(o);
  }
  upload() {
    var o;
    if (typeof window > "u" || !((o = window.mParticle) != null && o.ready))
      return Promise.reject("window.mParticle is not loaded");
    if (this.disableTracking) {
      console.warn("tracking disabled");
      return;
    }
    window.mParticle.ready(() => {
      window.mParticle.upload(), Promise.resolve();
    });
  }
  async trackEvent(o, t = u.Other, s, a) {
    var n;
    if (!((n = window.mParticle) != null && n.ready))
      return Promise.reject("window.mParticle is not loaded");
    if (this.disableTracking) {
      console.warn("mParticle client: tracking is disabled");
      return;
    }
    window.mParticle.ready(() => {
      const c = J.get(o);
      switch (c || console.warn("mParticle client: unknown eventName: " + o), c) {
        case i.screen_view:
          window.mParticle.logPageView(c, s);
          break;
        case i.product_impression:
          this.mParticleLogImpression(o, s, a);
          break;
        case i.search_suggestions:
          this.mParticleLogImpression(o, s, a);
          break;
        case i.generic_click:
          window.mParticle.logEvent(
            i.generic_click,
            u.Other,
            s
          );
          break;
        case i.error:
          window.mParticle.logEvent(
            i.error,
            u.Other,
            s
          );
          break;
        default:
          window.mParticle.logEvent(
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            c,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            t,
            s
          );
          break;
      }
      Promise.resolve();
    });
  }
  setUserIdentities(o, t, s) {
    var a;
    if (typeof window > "u" || !((a = window.mParticle) != null && a.ready))
      return Promise.reject("window.mParticle is not loaded");
    if (this.disableTracking) {
      console.warn("tracking disabled");
      return;
    }
    window.mParticle.ready(() => {
      switch (o) {
        case h.login:
          this.mParticleIdentityLogin(
            t,
            s
          );
          break;
        case h.logout:
          this.mParticleIdentityLogout(s);
          break;
        case h.modify:
          this.mParticleIdentityModify(
            t,
            s
          );
          break;
      }
      Promise.resolve();
    });
  }
  getBaseEventAttributes(o, t, s = "2.0.0") {
    return {
      cashrewards_event_name: o,
      ...this.getGenericEventAttributes(t, s),
      ...t
    };
  }
  getGenericEventAttributes(o, t = "2.0.0") {
    const a = this.env !== "prelive" && this.env !== "live" ? this.env : this.env === "prelive" || this.env === "live" ? this.env : "live", n = {
      screen_name: window.document.title,
      screen_version: t,
      page_location: window.location.href,
      page_hostname: window.location.hostname,
      page_path: window.location.pathname,
      page_fragment: window.location.hash,
      page_query: window.location.search,
      page_referrer: document.referrer,
      cashrewards_env_name: a ?? "local",
      ...o
    }, c = ee();
    return c != null && c.partner && (c != null && c.partnerReferenceId) && (n.application_referrer = c.partner, n.partner_reference_id = c.partnerReferenceId), n;
  }
  /**
   * This function allows to trigger specific product action event "logProductAction" from mparticle. https://docs.mparticle.com/developers/sdk/web/core-apidocs/classes/mParticle.eCommerce.html#method_logProductAction
   * @param productActionType https://github.com/cash-rewards/cr-ui-lib/blob/feature/CPS-9525-mparticle-events/packages/mparticle/src/models/Mparticle.interface.ts#L201
   * @param eventAttributes
   * @param products
   * @returns
   */
  trackProductActionEvent(o, t, s) {
    var a;
    if (!((a = window.mParticle) != null && a.ready))
      return Promise.reject("window.mParticle is not loaded");
    if (this.disableTracking) {
      console.warn("mParticle client: tracking is disabled");
      return;
    }
    window.mParticle.ready(() => {
      const n = s == null ? void 0 : s.map(
        (c) => window.mParticle.eCommerce.createProduct(
          c.name,
          c.id,
          c.price,
          c.quantity,
          c.variant,
          c.category,
          c.brand,
          c.position,
          c.coupon_code,
          c.custom_attributes
        )
      );
      window.mParticle.eCommerce.logProductAction(
        o,
        n,
        t
      );
    });
  }
  mParticleIdentityModify(o, t) {
    const s = {
      userIdentities: { ...o }
    };
    window.mParticle.Identity.modify(s, t);
  }
  mParticleIdentityLogout(o) {
    const t = {
      userIdentities: {}
    };
    window.mParticle.Identity.logout(t, o);
  }
  mParticleIdentityLogin(o, t) {
    const s = {
      userIdentities: { ...o }
    };
    window.mParticle.Identity.login(s, t);
  }
  mParticleLogImpression(o, t, s = []) {
    const a = s == null ? void 0 : s.map(
      (c) => window.mParticle.eCommerce.createProduct(
        c.name,
        c.id ?? "",
        c.price ?? 0,
        c.quantity,
        c.variant,
        c.category,
        c.brand,
        c.position,
        c.coupon_code,
        c.custom_attributes
      )
    ), n = window.mParticle.eCommerce.createImpression(
      o,
      a
    );
    window.mParticle.eCommerce.logImpression(n, t);
  }
}
const ie = (e) => {
  const o = window.getComputedStyle(e);
  return (o == null ? void 0 : o.display) !== "none" && o.visibility !== "hidden";
}, re = (e) => {
  const o = window.getComputedStyle(e);
  return (o == null ? void 0 : o.position) === "fixed";
}, se = (e, o, t, s = 1e3, a = null) => {
  let n;
  const c = {
    root: a,
    threshold: 0.5
    // This was the element being 50% in view
  };
  if (re(e) && ie(e))
    return t(), {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      disconnect: () => {
      }
    };
  const d = new IntersectionObserver((k) => {
    k.forEach((_) => {
      _.isIntersecting ? n = setTimeout(() => {
        t(), o && m();
      }, s) : clearTimeout(n);
    });
  }, c);
  d.observe(e);
  const m = () => {
    d.disconnect(), n && clearTimeout(n);
  };
  return {
    observer: d,
    timer: n,
    disconnect: m
  };
};
export {
  I as APPLICATION_REFERRER,
  K as ARRAY_ELEMENT_ID,
  W as ARRAY_ELEMENT_TYPE,
  O as CLICK_SOURCE_NAME,
  U as CONTENT_PROVIDER,
  G as CONTENT_TYPE,
  Z as ELEMENT_ACTION,
  Q as ELEMENT_POSITION,
  N as ERROR_SEVERITY,
  T as ERROR_VISIBILITY_LEVEL,
  r as EVENT_NAME,
  u as EVENT_TYPE,
  z as FLOW_NAME,
  V as IDENTITY_PROVIDER,
  h as IdentityAction,
  H as MERCHANT_REPORT_CATEGORY,
  P as MERCHANT_REPORT_SUBCATEGORY,
  i as MPARTICLE_EVENT,
  ce as MparticleClient,
  D as PRODUCT_ACTION_TYPE,
  M as PROMOTION_ACTIVATION_CHANNEL,
  C as PROMOTION_TYPE,
  Y as RAF_CHANNEL,
  B as SCROLL_AXIS,
  F as SCROLL_CONTEXT,
  X as SEARCH_METHOD,
  L as SORT_METHOD,
  A as SUBSCRIBE_STATUS,
  R as UNIVERSAL_CONTROL,
  S as UPDATE_TYPE,
  ee as getPartnerStore,
  se as isElementInView
};
